function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import m, { useMemo as d, useRef as M } from "react";
import { Features as H, Hidden as T } from '../internal/hidden.js';
import { useEvent as E } from './use-event.js';
import { useOwnerDocument as b } from './use-owner.js';
function N() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$defaultContainer = _ref.defaultContainers,
    o = _ref$defaultContainer === void 0 ? [] : _ref$defaultContainer,
    r = _ref.portals,
    u = _ref.mainTreeNodeRef;
  var f;
  var t = M((f = u == null ? void 0 : u.current) != null ? f : null),
    l = b(t),
    c = E(function () {
      var i, s, a;
      var n = [];
      var _iterator = _createForOfIteratorHelper(o),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          _e !== null && (_e instanceof HTMLElement ? n.push(_e) : "current" in _e && _e.current instanceof HTMLElement && n.push(_e.current));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (r != null && r.current) {
        var _iterator2 = _createForOfIteratorHelper(r.current),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var e = _step2.value;
            n.push(e);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var _iterator3 = _createForOfIteratorHelper((i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : []),
        _step3;
      try {
        var _loop = function _loop() {
          var e = _step3.value;
          e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || e.contains((a = (s = t.current) == null ? void 0 : s.getRootNode()) == null ? void 0 : a.host) || n.some(function (L) {
            return e.contains(L);
          }) || n.push(e));
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return n;
    });
  return {
    resolveContainers: c,
    contains: E(function (n) {
      return c().some(function (i) {
        return i.contains(n);
      });
    }),
    mainTreeNodeRef: t,
    MainTreeNode: d(function () {
      return function () {
        return u != null ? null : m.createElement(T, {
          features: H.Hidden,
          ref: t
        });
      };
    }, [t, u])
  };
}
function y() {
  var o = M(null);
  return {
    mainTreeNodeRef: o,
    MainTreeNode: d(function () {
      return function () {
        return m.createElement(T, {
          features: H.Hidden,
          ref: o
        });
      };
    }, [o])
  };
}
export { y as useMainTreeNode, N as useRootContainers };